import { Injectable } from '@angular/core';

@Injectable()
export class ColorManagerService {

    getColor(colorKey: string): string {
        let colorManager = window['colorManager'];
        if (colorManager) {
            return colorManager.getColor(colorKey);
        } else {
            return null;
        }
    }

}